import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { IdName } from '@shared/models/id-name';
import { TreatmentStageEnum } from '../models/treatment-stage.enum';
import { ProcedureMap } from '@shared/models/procedure-map';
import { defaultExpirationPeriodForReferral } from '@shared/models/consts';
import { SendToOption } from '@shared/models/send-to-option';

export interface OrderState {
	caseType: IdName | null;
	procedureMap: ProcedureMap | null;
	treatmentStage: IdName | null;
	treatmentStages: IdName[];
	currentAlignerId: string | null;
	isMultiBiteSelected: boolean;
	directToLab: boolean;
	sendTo: SendToOption | null;
	availableLabs: SendToOption[] | null;
	dueDate: Date | null;
	minimalAvailableDueDate: Date;
	maxDueDate: Date | null;
	availableCaseTypeIds: number[] | null;
	availableProcedureMaps: ProcedureMap[] | null;
	isFinalRecord: boolean;
	isTreatmentStageVisible: boolean;
	isDraftSelected: boolean;
	originalCaseTypeId: number | null;
}

export const getTreatmentStages = (): IdName[] => [
	{ Id: TreatmentStageEnum.InitialRecord, Name: 'Initial Record' },
	{ Id: TreatmentStageEnum.ProgressRecord, Name: 'Progress Record' },
	{ Id: TreatmentStageEnum.FinalRecord, Name: 'Final Record' }
];

export const getMinimalAvailableDueDate = (): Date => {
	const tomorrow = new Date();

	tomorrow.setDate(new Date().getDate() + 1);
	tomorrow.setHours(0, 0, 0, 0);

	return tomorrow;
};

export const createInitialState = (): OrderState => ({
	caseType: null,
	procedureMap: null,
	treatmentStage: null,
	treatmentStages: getTreatmentStages(),
	currentAlignerId: null,
	isMultiBiteSelected: false,
	directToLab: false,
	sendTo: null,
	availableLabs: null,
	dueDate: null,
	minimalAvailableDueDate: getMinimalAvailableDueDate(),
	maxDueDate: null,
	availableCaseTypeIds: null,
	availableProcedureMaps: null,
	isFinalRecord: false,
	isTreatmentStageVisible: false,
	isDraftSelected: false,
	originalCaseTypeId: null
});

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'order' })
export class OrderStore extends Store<OrderState> {
	constructor() {
		super(createInitialState());
	}

	addAvailableProcedureMap(procedureMap: ProcedureMap): void {
		this.update({ availableProcedureMaps: [procedureMap, ...(this.getValue().availableProcedureMaps ?? [])] });
	}

	updateIsDraft(newValue: boolean) {
		this.update({ isDraftSelected: newValue });
	}
}

export const getMaximumDueDateForReferral = (expirationPeriod = defaultExpirationPeriodForReferral): Date => {
	const maxDueDate = new Date();

	maxDueDate.setDate(new Date().getDate() + expirationPeriod);
	maxDueDate.setHours(0, 0, 0, 0);

	return maxDueDate;
};
